import {
  get,
  sortBy,
} from 'lodash-es'

const STORE_TYPES = {
  HQ: 'HEADQUARTERS',
  DC: 'DISTRIBUTION_CENTER',
  RS: 'SATELLITE',
}

const isType = (store, type) => {
  if (!store) return false
  if (!store.storeType) return false

  return store.storeType === type
}

const isHQ = store => isType(store, STORE_TYPES.HQ)
const isDC = store => isType(store, STORE_TYPES.DC)
const isRS = store => isType(store, STORE_TYPES.RS)

/**
 * Returns just the hours for a specific event type
 * expects there to just be one of those event types
 * in the returned data
 * @param  {Object} store The store data object
 * @param  {String} type  The type that the logic is searching for
 * @return {Array}       array of hours for type
 */
const getHoursForType = (store, type) => {
  const allEvents = get(store, 'retailStoreHoursEvents', [])
  return get(allEvents.find(event => event.hoursType === type), 'retailStoreHours', [])
}

const getSortedCurbsideHours = store => sortBy(getHoursForType(store, 'CurbsideHours'), hour => hour.id)
const getSortedStoreHours = store => sortBy(getHoursForType(store, 'NormalHours'), hour => hour.id)

/**
 * Returns an array of special event objects
 * for retails stores
 * @param  {Object} store The store data object
 * @return {Array}       array of special events
 */
const getSortedSpecialStoreHours = (store) => {
  const specialHours = get(store, 'retailStoreHoursEvents', [])
    .filter(hours => hours.hoursType === 'SpecialHours')

  // Show earlier days first
  return sortBy(specialHours, hour => hour.retailStoreHours[0].effectiveDate)
}

export default {
  isType,
  isHQ,
  isDC,
  isRS,
  STORE_TYPES,
  getSortedCurbsideHours,
  getSortedStoreHours,
  getSortedSpecialStoreHours,
}
